import { Injectable } from '@angular/core';
import { DangerousGoodItem, TransportMode } from '@hazmatsuite-next/ui';
import { forkJoin, map, of, take } from 'rxjs';
import { saveCompositePackageUpdateSuccess, saveSinglePackageUpdateSuccess } from '../store/package-list.actions';
import { Store } from '@ngrx/store';
import { Packages, PackagingModel, CompositePackagingModel, SinglePackagingModel } from '@hazmatsuite-next/easydgd-lib';
import { DangerousGoodService } from '@hazmatsuite-next/ui';

@Injectable({
  providedIn: 'root'
})
export class ReloadService {

  constructor(private dangerousGoodService: DangerousGoodService, private store: Store<{ packageList: { packages: Packages, tempPackage: PackagingModel } }>,) { }

  reloadCompositePackagingDangerousGoods(compositePackagingItems: CompositePackagingModel[], transportMode: TransportMode): void {
    if (!compositePackagingItems.some(pkg => pkg.Items.some(item => item.DangerousGoodId && !item.DangerousGood))) {
      return;
    }

    compositePackagingItems.filter(pkg => pkg.Items.some(item => item.DangerousGoodId && !item.DangerousGood)).map(pkg => {
      forkJoin(pkg.Items.map(item => {
        if (item.DangerousGood) {
          return of(pkg);
        }
        return this.dangerousGoodService.getDangerousGood(item.DangerousGoodId as number, transportMode).pipe(map((dangerousGood: DangerousGoodItem) => {
          pkg = {
            ...pkg,
            Items: pkg.Items.map(i => {
              if (i.InternalId === item.InternalId) {
                return {
                  ...i,
                  DangerousGood: dangerousGood
                };
              }
              return i;
            })
          }
        }))
      })).pipe(take(1)).subscribe(() => {
        this.store.dispatch(saveCompositePackageUpdateSuccess({ pkg: pkg }));
      });
    })
  }


  reloadSinglePackagingDangerousGoods(singlePackagingItems: SinglePackagingModel[], transportMode: TransportMode): void {
    singlePackagingItems.filter(pkg => !pkg.DangerousGood && pkg.DangerousGoodId).map(pkg => {
      this.dangerousGoodService.getDangerousGood(pkg.DangerousGoodId as number, transportMode).pipe(take(1)).subscribe((dangerousGood: DangerousGoodItem) => {
        this.store.dispatch(saveSinglePackageUpdateSuccess({
          pkg: {
            ...pkg,
            DangerousGood: dangerousGood
          }
        }));
      });
    });
  }

}
